import { type RelatedProduct } from "@/lib/content-service/types/ContentServiceProduct"

export const getSalePercentage = (product: RelatedProduct) => {
    const percentage = Math.round(
        (1 - (product.priceAsNumber ?? 0) / (product.priceBeforeDiscountAsNumber ?? 1)) *
            100
    )
    return percentage
}
